import React, { useState } from 'react'
import { Stepper } from 'react-form-stepper';
import './ServicesForm1.css'


function CPersonalInfo({ setfirstname ,  firstname ,  lastname , setlastname, setaddress , address , postcode , setpostcode, setdateofbirth, dateofbirth, ninumber, setninumber, utrnumber, setutrnumber ,step , setstep}) {

    // const [firstname, setfirstname] = useState();
    // const [lastname, setlastname] = useState();
    // const [email, setemail] = useState();
    // const [phone, setphone] = useState();
    // const [services, setservices] = useState();
    // const [soletrader, setsoletrader] = useState();
    // const [privatedriver, setprivatedriver] = useState();
    // const [deliverydriver, setdeliverydriver] = useState();
    // const [cis, setcis] = useState();
    // const [taxidriver, settaxidriver] = useState();
    // const [onlineseller, setonlineseller] = useState();
    // const [other, setother] = useState();
    // const [propertyaccount, setpropertyaccount] = useState();
    // const [companyname, setcompanyname] = useState();
    // const [companynumber, setcompanynumber] = useState();
    // const [paye, setpaye] = useState();
    // const [message, setmessage] = useState();    
    // const [nextstep, setnextstep] = useState(1);



    const submithandle = (e) => {
        e.preventDefault()
        setstep(step + 1)
    }


    return (
        <div>
            <div className='stepper-div1'>
                {/* <Stepper activeStep={0} steps={[{ label: 'Personal Detail' }, { label: 'Services' }, { label: 'Complete' }]} styleConfig={{
                    activeBgColor: '#485CE1',
                    activeTextColor: '#fff',
                    inactiveBgColor: '#fff',
                    inactiveTextColor: '#3033B5',
                    completedBgColor: '#2729a1',
                    completedTextColor: '#fff',
                    size: '3em'
                    
                }} className={ 'stepper'}
            stepClassName={ 'stepper__step'}>
                </Stepper> */}

                <div className='stepper-main-div1'>
                    <div className='stepper-main-div2'> 
                    <div className='stepper-main-div3'>
                        <button className='stepper-main-btn1-active'><span>1</span></button>
                            <div className= 'stepper-main-div4'>
                                <span>Personal Detail</span>
                            </div>
                        </div>
                         </div>

                    <div className='stepper-main-div2'>
                        <div className='stepper-main-line2' ><span></span></div>
                        <div className='stepper-main-div3'>
                            <button className='stepper-main-btn1'><span>2</span></button>
                            <div className='stepper-main-div4'>
                                <span>Tax Detail</span>
                            </div>
                        </div>
                    </div>

                    <div className='stepper-main-div2'>
                        <div className='stepper-main-line2' ><span></span></div>
                        <div className='stepper-main-div3'>
                            <button className='stepper-main-btn1'><span>3</span></button>
                            <div className='stepper-main-div4'>
                                <span>Complete</span>
                            </div>
                        </div>
                    </div>
                </div>


                <form className="service-contact-form"  onSubmit={submithandle}>
                   
                        <div class="row">
                            {/* <div className='col-12'>
                                <h1 className='forms-heading11'> Personal Information</h1>
                            </div> */}
                            <div class="col-lg-6 col-12 ">
                                <label className='form-labels'>First Name</label>
                                <input
                                    type="text"
                                    name="firstname"
                                    class="form-control contact-input-field5"
                                    placeholder="First Name"
                                    onChange={(e) => setfirstname(e.target.value)}
                                    value={firstname}
                                />
                            </div>
                            <div class="col-lg-6 col-12 mt-4 mt-lg-0">
                                <label className='form-labels'>Last Name</label>
                                <input
                                    type="text"
                                    name="lastname"
                                    onChange={(e) => setlastname(e.target.value)}
                                    class="form-control contact-input-field5"
                                    placeholder="Last Name"
                                    value={lastname}
                                />
                            </div>
                            <div class="col-lg-12 col-12 mt-4 mt-lg-5">
                                <label className='form-labels'>Address</label>
                                <input
                                    type="text"
                                    name="address"
                                    onChange={(e) => setaddress(e.target.value)}
                                    class="form-control contact-input-field5"
                                    placeholder='Address'
                                    value={address}
                                />
                            </div>
                            <div class="col-lg-6 col-12 mt-4 mt-lg-5">
                                <label className='form-labels'>Postcode</label>

                                <input
                                    type="number"
                                    name="postcode"
                                    onChange={(e) => setpostcode(e.target.value)}
                                    class="form-control contact-input-field5"
                                    placeholder="Postcode"
                                    value={postcode}
                                />
                            </div>

                            <div class="col-lg-6 col-12 mt-4 mt-lg-5">
                                <label className='form-labels'>Date of Birth</label>
                                <input
                                    type="date"
                                    name="dateofbirth"
                                    onChange={(e) => setdateofbirth(e.target.value)}
                                    class="form-control contact-input-field5"
                                    placeholder='Date of Birth'
                                    value={dateofbirth}
                                />
                            </div>

                            <div class="col-lg-6 col-12 mt-4 mt-lg-5">
                                <label className='form-labels'>NI Number</label>

                                <input
                                    type="number"
                                    name="ninumber"
                                    onChange={(e) => setninumber(e.target.value)}
                                    class="form-control contact-input-field5"
                                    placeholder="NI Number"
                                    value={ninumber}
                                />
                            </div>

                            <div class="col-lg-6 col-12 mt-4 mt-lg-5">
                                <label className='form-labels'>UTR Number</label>

                                <input
                                    type="number"
                                    name="utrnumber"
                                    onChange={(e) => setutrnumber(e.target.value)}
                                    class="form-control contact-input-field5"
                                    placeholder="UTR Number"
                                    value={utrnumber}
                                />
                            </div>

                        <div className="col-12 mt-5 contact-us-btn-div2">
                            <button
                                type="submit"
                                className="ml-sm-auto mx-sm-0 mx-auto contactus-form-btn4"
                            >
                                Next
                            </button>
                        </div>

                            </div>
                </form>
            </div>
        </div>
    )
}

export default CPersonalInfo
